/* eslint-disable import/no-unused-modules */
export interface Account {
  slug: string;
  name: string;
  owner: number;
  status: number;
  website: string;
  type: number;
  industry: number;
  size: number;
  is_personalization_supported: boolean;
  subscription_id: string;
  timezone: string;
  plan: AccountPlan;
}
export interface AccountPlan {
  id: string;
  category: PlanCategory;
  members_limit: number | null;
  number_of_solutions: number | null;
  allow_solutions_overage: boolean;
  records_per_solution: number | null;
  allow_records_overage: boolean;
  file_storage: number | null;
  allow_storage_overage: boolean;
  days_in_recycle_bin: number;
  features: AccountFeatures;
}
export enum PlanCategory {
  Free = "free",
  Trial = "trial",
  Team = "team",
  Pro = "pro",
  Enterprise = "enterprise",
}
export interface AccountFeatures {
  app_permissions: boolean;
  field_permissions: boolean;
  lock_view: boolean;
  view_folders: boolean;
  sso: boolean;
  mfa: boolean;
}
